import React, { useRef, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelectedFunActionContext } from "../../../Context/GlobalContext";
import AuftraegeUebersicht from "./AuftraegeUebersicht";
import InaktivAnlageUebersicht from "./InaktivAnlageUebersicht";
import NIOAnlageUebersicht from "./NIOAnlageUebersicht";
import UeberfaelligeAuftraege from "./UeberfaelligeAuftraege";

import { useChildInfoActionContext } from "../../../Context/GlobalContext";
import AppConstants from "../../../Constants/AppConstants";
const NavDetails = () => {
  let { fonctionid, fonctionsname } = useParams();
  const updateSelectedFunc = useSelectedFunActionContext();

  const updateChildInfo = useChildInfoActionContext();
  const isMountedRef = useRef(null);
  const [renderElement, setRenderElement] = useState(null);

  useEffect(() => {
    isMountedRef.current = true;
    updateChildInfo({
      equipId: AppConstants.DEFAULT_GUID,
      inventarnr: "",
      bezeichnung: "",
    });
    updateSelectedFunc(fonctionid);

    let tmp = null;
    if (isMountedRef.current) {
      switch (parseInt(fonctionid)) {
        case 3:
          tmp = (
            <InaktivAnlageUebersicht
              fonctionsname={fonctionsname}
              fonctionid={fonctionid}
            />
          );
          break;
        case 4:
          tmp = (
            <AuftraegeUebersicht
              fonctionsname={fonctionsname}
              fonctionid={fonctionid}
            />
          );

          break;
        case 5:
          tmp = (
            <NIOAnlageUebersicht
              fonctionsname={fonctionsname}
              fonctionid={fonctionid}
            />
          );
          break;

        case 6:
          tmp = (
            <UeberfaelligeAuftraege
              fonctionsname={fonctionsname}
              fonctionid={fonctionid}
            />
          );
          break;

        default:
          tmp = <div>Fehler aufgetreten!!</div>;
          break;
      }
    }
    setRenderElement(tmp);
  }, [fonctionid]);

  return <>{renderElement}</>;
};
export default NavDetails;
